import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=21c3d174&scoped=true&"
import script from "./Branch.vue?vue&type=script&lang=ts&"
export * from "./Branch.vue?vue&type=script&lang=ts&"
import style0 from "./Branch.vue?vue&type=style&index=0&id=21c3d174&lang=scss&scoped=true&"
import style1 from "./Branch.vue?vue&type=style&index=1&id=21c3d174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3d174",
  null
  
)

export default component.exports